import DataGrid from './DataGrid';

// export { Column } from './types/types';
export default DataGrid;
